// Modern JSX transform - React import not needed
import { memo } from 'react'

/**
 * LocationDisplay - Shows selected spot mode location coordinates
 * Displays lat/lng with hint about dragging marker
 * 
 * @component
 * @example
 * <LocationDisplay
 *   t={t}
 *   location={{lat: 40.7128, lng: -74.0060}}
 * />
 */
const LocationDisplay = memo(function LocationDisplay({
  t,
  location,
  label = null
}) {
  if (!location) return null

  return (
    <div className="mb-4">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
        </label>
      )}
      <div className="bg-gray-50 p-3 rounded-md border border-gray-200">
        <p className="text-sm text-gray-700 font-mono">
          {location.lat.toFixed(6)}, {location.lng.toFixed(6)}
        </p>
        <p className="text-xs text-gray-500 mt-1">
          {t('map.tapMapTip')}
        </p>
      </div>
    </div>
  )
})

export default LocationDisplay
